var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('app-layout-header'),_c('app-layout-body',[_c('app-layout-sub',{attrs:{"title":"智能搜索","menus":_vm.menus}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }